export default "__VITE_ASSET__DTX4EZEr__"